import { EmspUserInvoiceBaseModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/invoices-service-lib/src/wrapper/outputs/emsp-user-invoice-base.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { EmspBoInvoiceListEmspUserIdCell } from './emsp-bo-invoice-list-emsp-user-id.cell';
import { EmspBoInvoiceListEmspUserIdHeader } from './emsp-bo-invoice-list-emsp-user-id.header';

export const EmspBoInvoiceListEmspUserIdColumn: IdentifiedColumnDef<
  EmspUserInvoiceBaseModel,
  EmspUserInvoiceBaseModel['emspUser']['id']
> = {
  id: 'emspUserId',
  enableSorting: false,
  header: EmspBoInvoiceListEmspUserIdHeader,
  cell: EmspBoInvoiceListEmspUserIdCell,
};
